import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class Constants {

  public static protocol = "https://";

  // public static identityUrl = protocol + this.identityServer;

  // public static identityServer = "localhost:8000";
  // public static identityServer = "192.168.0.230:8000";
  public static identityServer = "81.10.102.137:8000";

  // public static fileServer = "localhost:8088";
  // public static fileServer = "192.168.0.230:8088";
  public static fileServer = "81.10.102.137:8088";

  // public static timeServer = "localhost:3000";
  // public static eventServer = "192.168.0.230:3000";
  public static eventServer = "81.10.102.137:3000";

  // public static nameServer = "localhost:8060";
  // public static nameServer = "192.168.0.230:8060";
  public static nameServer = "81.10.102.137:8060";

  public static max_file_size: number = 4; // Max File Size Size 4 MB
  
  public static httpOptions = {
    headers: new HttpHeaders(
      {'Content-Type': 'application/json'}
    ),
    withCredentials: true
  }

  static change: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public static onChange: Observable<boolean> = Constants.change.asObservable();
  
  public static broadcast() {
    this.change.next(!this.change.value);
    console.log("Broadcasting changed as " + this.change.value);
  }

  public static apply(settings: any) {
    if (settings) {
        // Constants.settings = settings;

        Constants.protocol = settings.protocol || Constants.protocol;
        // Constants.server = settings.server || Constants.server;
        Constants.identityServer = settings.identityServer || Constants.identityServer;
        // Constants.mailServer = settings.mailServer || Constants.mailServer;
        Constants.fileServer = settings.fileServer || Constants.fileServer;
        Constants.nameServer = settings.nameServer || Constants.nameServer;
        // Constants.timeServer = settings.timeServer || Constants.timeServer;
        Constants.eventServer = settings.eventServer || Constants.eventServer;
        Constants.max_file_size = settings.max_file_size || Constants.max_file_size;
        // Constants.reportServer = settings.reportServer || Constants.reportServer;
        // Constants.logServer = settings.logServer || Constants.logServer;
        // Constants.peerServer = settings.peerServer || Constants.peerServer;
        // Constants.iceServers = settings.iceServers || Constants.iceServers;
      
        Constants.broadcast();

        console.log("loaded Settings");
    } else {
        console.log("No settings returned");
    }

}

  
}